import img1 from "../../assets/Images/Event Booking/Shift Booking List.png"

export default function ShiftBookingList() {
  return (
    <section id="shift-booking-list" className="space-y-16">

      {/* SECTION TITLE */}
      <div>
        <h2 className="text-xl font-semibold text-[#C9A24E] mb-3">
          2.5 Shift Booking List
        </h2>
        <p className="text-slate-600 max-w-3xl">
          The Shift Events module displays all bookings that have been moved from
          their originally scheduled dates. It helps staff track rescheduled
          events and manage their updated timelines and payments.
        </p><br />
        <p className="text-slate-600">
          Shifted bookings occur when an event is postponed or rescheduled to a
          new date. This screen provides a centralized list of all such events
          along with their financial status and available actions.
        </p>
      </div>

      {/* OVERVIEW */}
      {/* <section className="bg-white border-l border-[#C9A24E] p-4">
        <h3 className="text-lg font-semibold mb-2">
          Overview
        </h3>
        
      </section> */}

      {/* NAVIGATION */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Navigation & Page Behavior
        </h3>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>
            Clicking <strong>Booking List</strong> navigates back to the main
            Event Bookings screen.
          </li>
          <li>
            Only bookings marked as <strong>Shifted</strong> appear here.
          </li>
          <li>
            Shifted events remain visible until they are confirmed or canceled.
          </li>
          <li>
            The <strong>Add New</strong> button redirects to the Add Booking form.
          </li>
        </ul>
      </section>

      {/* TABLE */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Shift Booking List Table
        </h3>

        <p className="text-slate-600 mb-4">
          The table lists all shifted bookings along with updated event and
          financial details.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Booking number and client name</li>
          <li>Event type and (new) event date</li>
          <li>Hall portion and slot</li>
          <li>Total booking amount</li>
          <li>Advance received</li>
          <li>Remaining due amount</li>
          <li>Status marked as Shifted</li>
        </ul>

        <div className="rounded-lg p-4 mt-4">
          <img src={img1} alt="" />
        </div>
      </section>

      {/* ACTIONS */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Available Actions for Shifted Bookings
        </h3>

        <p className="text-slate-600 mb-3">
          Shifted bookings support multiple actions to help staff finalize or
          further manage the event.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>
            <strong>Invoice</strong> – View or print the booking invoice
          </li>
          <li>
            <strong>Edit</strong> – Modify booking details or dates
          </li>
          <li>
            <strong>Receipt</strong> – Record additional payments
          </li>
          <li>
            <strong>Receipt Print</strong> – Print payment receipt
          </li>
          <li>
            <strong>Mark as Confirmed</strong> – Confirm the new event date
          </li>
          <li>
            <strong>Mark as Shifted</strong> – Update the shift reason or date
          </li>
          <li>
            <strong>Mark as Canceled</strong> – Cancel the shifted booking
          </li>
        </ul>
      </section>

      {/* FINANCIAL STATUS */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Financial Tracking for Shifted Events
        </h3>

        <p className="text-slate-600 mb-3">
          Payments already received remain linked to the booking even after
          shifting. Any remaining dues are carried forward to the new event
          date.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Advance payments remain intact</li>
          <li>Outstanding dues continue to be tracked</li>
          <li>No duplicate charges are created</li>
        </ul>
      </section>

      {/* TOTALS */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Summary Totals
        </h3>

        <p className="text-slate-600 mb-3">
          At the bottom of the table, EventFlow displays cumulative totals for
          quick financial overview.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Total value of shifted bookings</li>
          <li>Total advance amount received</li>
          <li>Total outstanding due amount</li>
        </ul>
      </section>

      {/* WHY IMPORTANT */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Why Shift Event Tracking Is Important
        </h3>

        <p className="text-slate-600 max-w-3xl">
          Tracking shifted events prevents scheduling conflicts, preserves
          payment history, and ensures transparency when events are postponed.
          It helps staff maintain operational control without losing financial
          accuracy.
        </p>
      </section>

    </section>
  );
}
